import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ui } from '../../assignment-ui';

/** Compact six-segment stage indicator with the stage name and time in stage. */
@Component({
  selector: 'mbt-stage-segments',
  template: `
    <div class="flex flex-col gap-1.5">
      <div class="grid grid-cols-[repeat(6,16px)] gap-[3px]" aria-hidden="true">
        @for (filled of segments(); track $index) {
          <i class="h-1.5 rounded-[3px]"
            [class]="filled ? 'bg-(--app-accent)' : 'bg-(--bg-alt) shadow-[inset_0_0_0_1px_var(--border-subtle)]'"></i>
        }
      </div>
      <div>
        <b class="font-(family-name:--font-display) text-base font-bold text-(--fg-1)">{{ label() }}</b>
        @if (elapsed()) {
          <span class="ml-1.5" [class]="late() ? lateText : ui.sub">{{ elapsed() }}</span>
        }
      </div>
    </div>
  `,
  host: { style: 'display: contents' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StageSegments {
  protected readonly ui = ui;
  protected readonly lateText = 'font-(family-name:--font-fallback) text-xs font-bold leading-[1.45] text-(--danger)';

  /** 0 Invited … 5 Completed. */
  readonly stage = input.required<number>();
  readonly label = input.required<string>();
  readonly elapsed = input<string>('');
  readonly late = input(false);

  protected readonly segments = computed(() =>
    Array.from({ length: 6 }, (_, index) => index <= this.stage()),
  );
}
